// components/common/modals/ViewPostsModal.tsx
import React from "react";
import {
  ModalBackdrop,
  ModalContent,
  ModalTitle,
  CloseButton,
  PostsGridContainer,
  PostCard,
  PostImage,
  PostDescription,
  PostUser,
  ModalLoading,
  ModalError,
  EmptyState
} from "components/common/modals/modal.styles";
import { useNavigate } from "react-router-dom";

interface Post {
  id: number;
  imageUrl: string;
  description: string;
  user?: string;
}

interface ViewPostsModalProps {
  posts: Post[];
  isLoading: boolean;
  error: string | null;
  onClose: () => void;
}

const ViewPostsModal: React.FC<ViewPostsModalProps> = ({
  posts,
  isLoading,
  error,
  onClose
}) => {
  const navigate = useNavigate();
  return (
    <ModalBackdrop>
      <ModalContent>
        <CloseButton onClick={onClose}>×</CloseButton>
        <ModalTitle>Project Posts</ModalTitle>

        {isLoading && <ModalLoading>Loading posts...</ModalLoading>}
        
        {error && <ModalError>{error}</ModalError>}
        
        {!isLoading && !error && (
          <>
            {posts.length === 0 ? (
              <EmptyState>
                <p>This project doesn't have any posts yet</p>
              </EmptyState>
            ) : (
              <PostsGridContainer>
                {posts.map((post) => (
                  <PostCard key={post.id}>
                    <PostImage 
                      src={post.imageUrl}
                      alt={`Post ${post.id}`}
                      onClick={() => navigate(`/post/${post.id}`)}
                      style={{ cursor: "pointer" }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = "https://via.placeholder.com/150";
                      }}
                    />
                    <PostDescription>
                      {post.description || "No description"}
                    </PostDescription>
                  </PostCard>
                ))}
              </PostsGridContainer>
            )}
          </>
        )}
      </ModalContent>
    </ModalBackdrop>
  );
};

export default ViewPostsModal;